//App.js
import React, { useEffect,useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { Navbar, Footer, Sidebar, ThemeSettings, CreateInvoice } from './components';
import {
  Login, Dashboard, Settings, Departments,
  // Product categories
  Categories, NewCategory,EditCategory, ViewCategory,DeleteCategory,
  // Products
  Products, NewProduct,EditProduct,ViewProduct,
  Prices, 
  AllProductsPrices, CategoriesPrices, 
  // Quantity Adjustment
  Quantities,NewQuantityAdjustment,EditQuantityAdjustment,ApproveQuantityAdjustment,ViewQuantityAdjustment,
  // sales quotations
  Quotations,NewQuotation,EditQuotation,DeleteQuotation,ApproveQuotation,CancelQuotation,RestoreQuotation, 
  ViewQuotation,
  Pos,
    // purchase ordes
  Orders,NewOrder, EditOrder,DeleteOrder, CancelOrder, ViewOrder,ApproveOrder,RestoreOrder,
  // purchase invoices
  PurchaseInvoices,NewInvoice,ApproveInvoice,CancelInvoice,DeleteInvoice,RestoreInvoice,ViewInvoice,
  EditInvoice,Deliveries,Invoices,
  // puchase payment
  PurchasePayment, NewPurchasePayment, EditPurchasePayment,ApprovePurchasePayment,ViewPurchasePayment,
  CancelPurchasePayment,Pay,EnterReceipt,RestorePayment,
  //purchase delivery
  EditPurchaseDelivery,
  //sales invoice
  Invoice,NewSalesInvoice,ViewSalesInvoice,ApproveSalesInvoice,
  //sales payments
  NewSalesPayment,
  //employees
  Employees, NewEmployee,EditEmployee,ViewEmployee, DeleteEmployee,
  //suppliers
  Suppliers,NewSupplier,EditSupplier,ViewSupplier,
  //customers
  Customers,NewCustomer,EditCustomer,ViewCustomer,
  Calendar,
  // Users
  Users,NewUser,EditUser,ViewUser,DeleteUser,
  // roles
  Roles, NewRole,EditRole,DeleteRole,
  Stacked, Pyramid,  Kanban,Line, Area, Bar, Pie, Financial, 
  ColorPicker, ColorMapping,  Editor,
 SelectedProductsPrices
} from './pages';
import './App.css';
import AppContextProvider from './contexts/AppContextProvider';
const App= () => {
  return (
  <AppContextProvider>
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/kanban" element={<Kanban />} />
            {/* pages  */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/settings" element={<Settings />} /> 
            <Route path="/departments" element={<Departments />} />

            <Route path="/categories" element={<Categories />} />
            <Route path="/categories/new" element={<NewCategory />} />
            <Route path="/categories/edit/:id" element={<EditCategory/>} />
            <Route path="/categories/view/:id" element={<ViewCategory/>} />
            <Route path="/categories/delete/:id" element={<DeleteCategory/>} />
          
            <Route path="/products" element={<Products />} />
            <Route path="/products/new" element={<NewProduct />} />
            <Route path="/products/edit/:id" element={<EditProduct/>} />
            <Route path="/products/view/:id" element={<ViewProduct/>} />
            
            {/* Quantity Adjustment */}
            <Route path="/quantity_adjustments/new" element={<NewQuantityAdjustment />} />
            <Route path="/quantity_adjustments/edit/:id" element={<EditQuantityAdjustment />} />
            <Route path="/quantity_adjustments/approve/:id" element={<ApproveQuantityAdjustment />} />
            <Route path="/quantity_adjustments/view/:id" element={<ViewQuantityAdjustment />} />
            
            {/* purchase orders */}
            <Route path="/orders" element={<Orders />} />
            <Route path="/orders/new" element={<NewOrder />} />
            <Route path="/orders/edit/:id" element={<EditOrder />} />
            <Route path="/orders/approve/:id" element={<ApproveOrder />} />
            <Route path="/orders/delete/:id" element={<DeleteOrder />} />
            <Route path="/orders/cancel/:id" element={<CancelOrder />} />
            <Route path="/orders/view/:id" element={<ViewOrder />} />
            <Route path="/orders/restore/:id" element={<RestoreOrder />} />
            {/* purchase invoices */}
            <Route path="/invoices" element={<PurchaseInvoices />} />
            <Route path="/purchase/invoice/new/:id" element={<NewInvoice  />} />
            <Route path="/purchase/invoice/edit/:id" element={<EditInvoice  />} />
            <Route path="/purchase/invoice/approve/:id" element={<ApproveInvoice  />} />
            <Route path="/purchase/invoice/cancel/:id" element={<CancelInvoice  />} />
            <Route path="/purchase/invoice/delete/:id" element={<DeleteInvoice  />} />
            <Route path="/purchase/invoice/restore/:id" element={<RestoreInvoice  />} />
            <Route path="/purchase/invoice/view/:id" element={<ViewInvoice  />} />
            {/* end purchase invoices */}

            {/* purchase payments */}
            <Route path="/payments" element={<PurchasePayment  />} />
            <Route path="/purchase/payment/new/:id" element={<  NewPurchasePayment  />} />
            <Route path="/purchase/payment/edit/:id" element={<  EditPurchasePayment  />} />
            <Route path="/purchase/payment/approve/:id" element={<  ApprovePurchasePayment  />} />
            <Route path="/purchase/payment/view/:id" element={<  ViewPurchasePayment  />} />
            <Route path="/purchase/payment/cancel/:id" element={<  CancelPurchasePayment  />} />
            <Route path="/purchase/payment/restore/:id" element={<  RestorePayment  />} />
           
            <Route path="/purchase/payment/pay/:id" element={<  Pay  />} />
            <Route path="/purchase/payment/receipt/:id" element={<  EnterReceipt  />} />
            <Route path="/deliveries" element={<Deliveries />} />
            <Route path="/quantities" element={<Quantities />} />
            <Route path="/prices" element={<Prices />} />
             <Route path="/prices/adjust-all-products-prices" element={<AllProductsPrices />} />
            <Route path="/prices/adjust-product-categories-prices" element={<CategoriesPrices />} />
            <Route path="/prices/adjust-selected-products-prices" element={<SelectedProductsPrices />} />
            {/* <Route path="/example" element={<Example />} /> */} 
            <Route path="/pos" element={<Pos />} />
            {/* Sales Quotations */}
            <Route path="/quotations" element={<Quotations />} />
            <Route path="/quotations/new" element={<NewQuotation />} />
            <Route path="/quotations/edit/:id" element={<EditQuotation />} />
            <Route path="/quotations/view/:id" element={<ViewQuotation />} />
            <Route path="/quotations/approve/:id" element={<ApproveQuotation />} />
            <Route path="/quotations/delete/:id" element={<DeleteQuotation />} />
            <Route path="/quotations/cancel/:id" element={<CancelQuotation />} />
            <Route path="/quotations/restore/:id" element={<RestoreQuotation />} />

            {/* purchase delivery  */}
            <Route path="/purchase/deliveries/edit/:id" element={<EditPurchaseDelivery />} />
            
            {/* sales invoice */}
            <Route path="/invoice" element={<Invoice />} />
            <Route path="/sales/invoices/new/:id" element={<NewSalesInvoice />} />
            <Route path="/sales/invoices/approve/:id" element={<ApproveSalesInvoice />} />
            <Route path="/sales/invoices/view/:id" element={<ViewSalesInvoice />} />
            

            {/* sales Payements */}
  
            <Route path="/sales/payments/new/:id" element={<NewSalesPayment />} />


      
         
            {/* Suppliers*/}
            <Route path="/suppliers" element={<Suppliers />} />
            <Route path="/suppliers/new" element={<NewSupplier />} />
            <Route path="/suppliers/edit/:id" element={<EditSupplier />} />
            <Route path="/suppliers/view/:id" element={<ViewSupplier />} />

            {/* Customers */}
            <Route path="/customers" element={<Customers />} />
            <Route path="/customers/new" element={<NewCustomer />} />
            <Route path="/customers/edit/:id" element={<EditCustomer />} />
            <Route path="/customers/view/:id" element={<ViewCustomer />} />

            {/* employees */}
            <Route path="/employees" element={<Employees />} />
            <Route path="/employees/new" element={<NewEmployee />} />
            <Route path="/employees/edit/:id" element={<EditEmployee />} />
            <Route path="/employees/view/:id" element={<ViewEmployee />} />
            <Route path="/employees/deactivate/:id" element={<DeleteEmployee />} />
            {/* Users */}
            <Route path="/users" element={<Users />} />
            <Route path="/users/new" element={<NewUser />} />
            <Route path="/users/edit/:id" element={<EditUser />} />
            <Route path="/users/view/:id" element={<ViewUser />} />
            <Route path="/users/delete/:id" element={<DeleteUser />} />

            <Route path="/roles" element={<Roles />} />
            <Route path="/roles/new" element={<NewRole />} />
            <Route path="/roles/edit/:id" element={<EditRole />} />
            <Route path="/roles/delete/:id" element={<EditRole />} />
          
            <Route path="/kanban" element={<Kanban />} />
            <Route path="/editor" element={<Editor />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/color-picker" element={<ColorPicker />} />
            <Route path="/line" element={<Line />} />
            <Route path="/area" element={<Area />} />
            <Route path="/bar" element={<Bar />} />
            <Route path="/pie" element={<Pie />} />
            <Route path="/financial" element={<Financial />} />
            <Route path="/color-mapping" element={<ColorMapping />} />
            <Route path="/pyramid" element={<Pyramid />} />
            <Route path="/stacked" element={<Stacked />} />
            {/* ... other routes */}
            {/* apps  */}
            <Route path="/kanban" element={<Kanban />} />
            <Route path="/editor" element={<Editor />} />
            <Route path="/calendar" element={<Calendar />} />
            <Route path="/color-picker" element={<ColorPicker />} />

            {/* charts  */}
            <Route path="/line" element={<Line />} />
              <Route path="/area" element={<Area />} />
              <Route path="/bar" element={<Bar />} />
              <Route path="/pie" element={<Pie />} />
              <Route path="/financial" element={<Financial />} />
              <Route path="/color-mapping" element={<ColorMapping />} />
              <Route path="/pyramid" element={<Pyramid />} />
              <Route path="/stacked" element={<Stacked />} />
            </Routes>
           
            <Footer />
      </BrowserRouter>
 

  </AppContextProvider>
  );
};


export default App;
